// extracted by mini-css-extract-plugin
module.exports =  {"ChatUserOverview":"Y0RtPaUPPvm3FsUFp7Lk"};